import React, {useEffect, useState, useRef} from 'react'
import { provinces, productOptions } from '../Options'
import { setYear } from 'date-fns'
import Sidebar from '../Sidebar'
// import env from 'react-dotenv'

export default function AgronForm() {

  const [form, setForm] = useState({
    crop:"",
    agronName:"",
    province:"",
    provinceId:"",
    LCU:"",
    cropCondition:"",
    experience:"",
    description:"",
    year:"",
    surveyType:""
  })
  const [provs, setProvs] = useState([])

  const [lcuOptions, setLcuOptions] = useState([])
  const [lcuOptions2, setLcuOptions2] = useState([])
  //references
  const ref1 = useRef()
  const ref2 = useRef()
  const ref3 = useRef()
  const ref4 = useRef()
  const ref5 = useRef()
  const ref6 = useRef()
  const ref7 = useRef()
  const yRef = useRef()
  const sRef = useRef()


  //crop handler
  const cropHandler = (e) =>{
    const val = e.target.value.toLowerCase()
    setForm({...form, crop:val})
  } 
  //agron Name handler
  const agronName = (e) =>{
    setForm({...form, agronName:e.target.value})
  }

  //lcu
  const BalochistanLCU = [
    {id:1, name:"Central Balochistan"},
    {id:2, name:"Lower Balochistan"},
    {id: 3, name:"Uppwer Balochistan"}
  ]

  const FATALCU =[
    {id:4, name:"Central F.A.T.A"},
    {id:5, name:"Lower F.A.T.A"},
    {id: 6, name: "Upper F.A.T.A" }
  ]

  const KPKLCU = [
    {id: 7, name:"Central KPK" },
    {id: 8, name:"Lower KPK"},
    {id: 9, name:"Upper KPK"}
  ]

  const PunjabLCU = [
    {id: 10, name:"Central Punjab"},
    {id: 11, name:"South Punjab"},
    {id: 12, name:"Upper Punjab"}
  ]

  const  SindhLCU = [
    {id: 13, name:"Central Sindh"},
    {id: 14, name:"Lower Sindh"},
    {id: 15, name:"Upper Sindh"}
  ]
  

  //province
  const provinceHandler =(e)=>{
    const selectedName = e.target.value;
    const selectedOption = provinces.find(province => province.name === selectedName);

    if(selectedName === "Balochistan"){
      setLcuOptions(BalochistanLCU)
    }
    else if(selectedName === "F.A.T.A" ){
      setLcuOptions(FATALCU)
    }
    else if(selectedName === "KPK"){
      setLcuOptions(KPKLCU)
    }
    else if(selectedName === "Punjab"){
      setLcuOptions(PunjabLCU)
    }
    else if(selectedName === "Sindh"){
      setLcuOptions(SindhLCU)
    }
    else if(selectedName.length < 1){
      setLcuOptions(lcuOptions2)
    }
   // console.log(selectedOption)
    setForm({...form, province: e.target.value, provinceId:selectedOption.value})
  }


   const provHandler =(e)=>{
    const selectedName = e.target.value;
    const selectedOption = provs.find(prov => prov.name === selectedName);
   // console.log(selectedOption)
    setForm({...form, province: e.target.value, provinceId:selectedOption.value})
  }

  //LCU handler
  const lcuHandler =(e) =>{
    setForm({...form, LCU:e.target.value})
  }

  //cropcondition handler
  const cropConditionHandler = (e) =>{
    setForm({...form, cropCondition:e.target.value})
  }

  //experience handler
  const experienceHandler =(e) =>{
    setForm({...form, experience:e.target.value})
  }

  //description handler
  const descriptionHandler =(e) =>{
    setForm({...form, description:e.target.value})
  }

  //reset handler
  const reset = () =>{
    ref1.current.value=''
    ref2.current.value=''
    ref3.current.value=''
    ref4.current.value=''
    ref5.current.value=''
    ref6.current.value=''
    ref7.current.value=''
    sRef.current.value = ''
    yRef.current.value=''
    setForm({
      crop:"",
      agronName:"",
      province:"",
      provinceId:"",
      LCU:"",
      cropCondition:"",
      experience:"",
      description:"",
      year:"",
      surveyType:""
    })
  }

  //year handler
  const yearHandler = (e) =>{
    const x = e.target.value
    setForm({...form, year: x})
  }

  //surveY type value
  const surveyTypeHandler =(e) =>{
    setForm({...form, surveyType: e.target.value})
  }

  //const gerrit
  const gerrit = async (e) =>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/getLCU`,{
      headers:{
        'x-access-token': token
      }
    })
    const data = await response.json()
    setLcuOptions(data)
    setLcuOptions2(data)
  }

  const getProv = async (e) =>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/getProvince`,{
      headers: {
        'x-access-token': token
      }
    })
    const data = await response.json()
    setProvs(data)
  }

  useEffect(()=>{
    gerrit()
    getProv()
  },[])

  useEffect(()=>{
   // console.log(lcuOptions)
   // console.log(provs)
  }, [lcuOptions])

  //submission handler
  const handleSubmit = async (e) =>{
    e.preventDefault()
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/create-agron`, {
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        'x-access-token':token
      },
      body:JSON.stringify(form)
    })
        // .then(console.log(form))
        // .then(console.log("Successfully submitted!")).then(reset())
  
  }

  useEffect(()=>{
   // console.log(form)
  },[form.year])
  
  return (
    <>
      <div className="sidebar">
    <Sidebar/>
  </div>
    <div id='tabler'>
      <h1>Agron Form</h1>
    <form onSubmit={handleSubmit} className='needs-validation'>

      <div className="row">
        <div className="col-md-6">
        <label htmlFor="num-value" className="form-label">Year</label>
      <div class="input-group mb-3">
      <select className="form-select" ref={yRef}  id="num-value" onChange={yearHandler} required aria-label="Select example">
                    <option value="">Select year</option>
                    <option value="2025-26">2025-26</option>
                          <option value="2024-25">2024-25</option>
                          <option value="2023-24">2023-24</option>
                          <option value="2022-23">2022-23</option>
                          <option value="2021-22">2021-22</option>
                          <option value="2020-21">2020-21</option>
                          <option value="2019-20">2019-20</option>
                          <option value="2018-19">2018-19</option>
                          <option value="2017-18">2017-18</option>
                          <option value="2016-17">2016-17</option>
                          <option value="2015-16">2015-16</option>
                          <option value="2014-15">2014-15</option>
                          <option value="2013-14">2013-14</option>
                          <option value="2012-13">2012-13</option>
                          <option value="2011-12">2011-12</option>
                          <option value="2010-11">2010-11</option>
                    </select>       
                    </div>
        </div>

        <div className="col-md-6">

        <div class="form-group">
    <label for="inputAddress2">Survey Type</label>
    <select className="form-select" ref={sRef}  id="num-value" onChange={surveyTypeHandler} required aria-label="Select example">
                    <option value="">Select survey type</option>
                    <option value="Intention">Intention</option>
                    <option value="Sowing">Sowing</option>
                    <option value="Crop-Condition">Crop Condition</option>
                    <option value="Post-Harvest">Post Harvest</option>
                    </select>
  </div>
        </div>
      </div>


<div className="row">
  <div className="col-md-6">
  <div class="form-group">
    <label for="inputAddress2">Agron Name</label>
    <input type="text" required id="num-value" ref={ref1} onChange={agronName} class="form-control"   />
  </div>
  </div>

  <div className="col-md-6">
  <div class="form-group">
    <label for="inputAddress2">Experience</label>
    <input type="number" required id="num-value" ref={ref2} onChange={experienceHandler} class="form-control"   />
  </div>
  </div>
</div>
 
 
<div className="row">
  <div className="col-md-6">
  <label htmlFor="inputGroupSelect07" className="form-label">Crop</label>
            <div className="input-group mb-3">
                <select className="form-select" ref={ref3}  id="num-value" onChange={cropHandler} required aria-label="Select example">
                    <option value="">Select Crop</option>
                    {productOptions.map((productOption) => (
                        <option key={productOption.value} value={productOption.text}>{productOption.text}</option>
                    ))}
                </select>
            </div>
  </div>
  <div className="col-md-6">
                    
            <label htmlFor="inputGroupSelect07" className="form-label">Province</label>
            <div className="input-group mb-3">
                <select className="form-select" ref={ref4}  id="num-value" onChange={provinceHandler} required aria-label="Select example">
                    {/* <option value="">Select Province</option> */}
                    {provs.map((prov) => (
                        <option key={prov.id} value={prov.province_en}>{prov.province_en}</option>
                    ))}
                </select>
            </div>
  </div>
</div>

<div className="row">
  <div className="col-md-6">
  <label htmlFor="inputGroupSelect07" className="form-label">LCU</label>
            <div className="input-group mb-3">
                <select className="form-select" ref={ref5}  id="num-value" onChange={lcuHandler} required aria-label="Select example">
                    <option value="">Select LCU</option>
                    {lcuOptions.map((lcuOption) => (
                        <option key={lcuOption.id} value={lcuOption.name}>{lcuOption.name}</option>
                    ))}
                </select>
            </div>
  </div>
  <div className="col-md-6">
  <div class="form-group">
    <label for="inputAddress2">Crop Condition</label>
    <input type="text" required ref={ref6} onChange={cropConditionHandler} class="form-control" id="num-value"  />
  </div>
  </div>
</div>
     



  

  <div class="mb-3">
  <label for="exampleFormControlTextarea1" class="form-label">Description</label>
  <textarea class="form-control" required ref={ref7} id="num-value" onChange={descriptionHandler} maxLength={160} rows="3"></textarea>
</div>
<p style={{color:"grey"}}>160 characters</p>

<button type="submit"  className="btn submit-btn">Submit</button>

     </form>
    </div>
    </>
  
  )
}
